export const blockIconsActionEvent = (
	<span className='material-symbols-outlined'>event</span>
);
